<template>
    <Widget title="Todays Bell Schedule"
        headerLink="scheduler/day"
        :iconSrc="require('../../../assets/images/home_icons/scheduler.png')"
    >
        <div class="d-flex flex-column">
            <div class="d-flex justify-content-between mb-1">
                <div>
                    <p class="text-left mb-0" style="font-size: large">
                        <b v-if="current_server_time.hasOwnProperty('_isValid')">{{ current_server_time.format('h:mm:ss a') }}</b>
                    </p>
                </div>
                <div class="text-right w-25">
                    <button type="button" class="btn btn-sm btn-light w-100" @click="stopActiveBells">
                        <i class="fa fa-stop fa-fw" aria-hidden="true"></i>
                        Stop Active
                    </button>
                </div>
            </div>
            <div class="d-flex justify-content-between" style="font-size: large; line-height: 1">
                <div class="my-auto">
                    <p class="text-left mb-0">Next bell
                        <b v-if="schedule_info.next_bell_time._isValid === true">
                            {{ relativeNextBell }}
                        </b>
                        <b v-else>N/A</b>
                    </p>
                </div>
                <div class="text-right my-auto w-25">
                    <button class="btn btn-sm btn-light w-100" @click="showExceptionModal">
                        <i class="fa-solid fa-pen-to-square"></i>&nbsp;Date options
                    </button>
                </div>
            </div>

            <DaySchedule :bells="all_schedule_items" :current_time="current_server_time" :schedules_for_today="schedules_for_today" />
        </div>

        <Modal modal_id="exceptionModal">
            <template v-slot:title>
                <h2>Date Options for {{ formatted_date_long }}</h2>
            </template>
            <template v-slot:body>
                <DateOptionsForm :date="formatted_date_short" :callback="handleExceptionEdited"></DateOptionsForm>
            </template>
        </Modal>
    </Widget>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Widget from '../Widget.vue';
import DaySchedule from './DaySchedule.vue';
import ScheduleNames from './ScheduleNames.vue';
import Modal from '../../Modal.vue';
import DateOptionsForm from '../../Scheduler/Calendar/DateOptionsForm.vue';

export default {
    components: { Widget, DaySchedule, ScheduleNames, Modal, DateOptionsForm },
    data() {
        return {
            schedules_for_today: [],
            all_schedule_items: [],
            formatted_date_long: moment(this.current_server_time).format('MMMM Do YYYY'),
            formatted_date_short: moment(this.current_server_time).format('YYYY-MM-DD')
        }
    },
    computed: {
        ...mapGetters({
            current_server_time: 'currentServerTime',
            schedule_info: 'scheduleInfo',
            calendar_events: 'allCalendarEvents',
            day_schedule_items: 'allDayScheduleItems',
            day_schedule_items_total_pages: 'dayScheduleItemsTotalPages',
        }),
        relativeNextBell() {
            if(this.schedule_info.next_bell_time < this.current_server_time) {
                this.$store.dispatch('getScheduleInfo');
                return 'in progress'
            }
            return this.schedule_info.next_bell_time.from(this.current_server_time)
        }
    },
    watch: {
        calendar_events(events) {
            const filtered_calendar_events = events.filter(event => {
                const start = moment(event.start);
                const end = moment(event.end);
                const today = moment().startOf('day');
                return today.isSameOrAfter(start) && today.isSameOrBefore(end);
            });
            this.schedules_for_today = filtered_calendar_events;
        },
        schedules_for_today(schedules) {
            this.all_schedule_items = [];
            schedules.forEach(schedule => {
                this.getScheduleItems(schedule.day_schedule_id);
            })
        }
    },
    created() {
        this.$store.dispatch('getCurrentServerTime');
        this.$store.dispatch('getScheduleInfo');
        this.$store.dispatch('getCalendarEvents', moment())
    },
    methods: {
        stopActiveBells() {
            this.g2dialog.$confirm('You are about to stop active bells. Continue?')
                .then(confirmed => confirmed && this.$store.dispatch('stopActiveBells'))
        },
        getScheduleItems(schedule_id) {
            let items = [];
            this.$store.dispatch('getDayScheduleItems', {
                dayScheduleId: schedule_id,
                zone_id: 0,
                page: 1
            }).then(() => {
                items = [...this.day_schedule_items];
                if(this.day_schedule_items_total_pages > 1) {
                    for(let page = 2; page <= this.day_schedule_items_total_pages; page++) {
                        this.$store.dispatch('getDayScheduleItems', {
                            dayScheduleId: schedule_id,
                            zone_id: 0,
                            page: page
                        }).then(() => {
                            items = [...items, ...this.day_schedule_items];
                            this.all_schedule_items = [...this.all_schedule_items, ...items]
                        })
                    }
                } else {
                    this.all_schedule_items = [...this.all_schedule_items, ...items]
                }
            });
        },
        showExceptionModal() {
            $('#exceptionModal').modal('show');
        },
        hideExceptionModal() {
            $('#exceptionModal').modal('hide');
        },
        handleExceptionEdited(status) {
            if(status === 'success') {
                this.$store.dispatch('getCalendarEvents', moment());
                this.$store.dispatch('getScheduleInfo');
            }
            this.hideExceptionModal();
        }
    }
}
</script>